import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_URL } from "../../config";
import * as signalR from '@microsoft/signalr';

const InformationSignalR = ({ onMessageReceived }) => {
  const { userData } = useSelector(state => state.auth);
  const [hubConnection, setHubConnection] = useState(null);

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(`${API_URL}/informations?userId=${userData.id}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        withCredentials: true,
      })
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect(0, 0, 10000)
      .build();

    setHubConnection(connection);

    return () => {
      connection.stop();
    };
  }, [userData]);

  useEffect(() => {
    if (hubConnection) {
      hubConnection.start()
        .then(() => {
          hubConnection.on('ReceiveNotification', onReceiveNotification);
        })
        .catch(error => {
          console.error('Error establishing SignalR connection:', error);
        });
    }
  }, [hubConnection]);

  const onReceiveNotification = (message) => {
    onMessageReceived(message); 
  };

  return <></>;
};

export default InformationSignalR;

